class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector("swiper-slide")) {
            this.classList.add("product-recommendations--loaded");
          }

          this.initiateSwiper();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }

  initiateSwiper() {
    this.swiperEl = this.querySelector("swiper-container");
    this.swiperParams = {
      slidesPerGroup: 1,
      slidesOffsetAfter: this.getSlidesOffset(),
      slidesOffsetBefore: this.getSlidesOffset(),
      slidesPerView: "auto",
      spaceBetween: 8,
      navigation: {
        prevEl: '.product-recommendations button[data-direction="prev"]',
        nextEl: '.product-recommendations button[data-direction="next"]',
      },
      breakpoints: {
        750: {
          spaceBetween: 16,
        },
      },
    };

    Object.assign(this.swiperEl, this.swiperParams);
    this.swiperEl.initialize();
    this.swiperEl.swiper.on("resize", this.onSwiperResize.bind(this));
  }

  onSwiperResize() {
    this.swiperEl.slidesOffsetAfter = this.getSlidesOffset();
    this.swiperEl.slidesOffsetBefore = this.getSlidesOffset();
  }

  getSlidesOffset() {
    const pageWidthStyle = getComputedStyle(document.querySelector(".page-width")).getPropertyValue("max-width");
    const pageWidth = parseInt(pageWidthStyle, 10);
    const pageMarginStyle = getComputedStyle(document.querySelector(".page-width")).getPropertyValue("padding-left");
    const slidesOffset =
      window.innerWidth > pageWidth
        ? (window.innerWidth - pageWidth) / 2 + parseInt(pageMarginStyle, 10)
        : parseInt(pageMarginStyle, 10);
    return slidesOffset;
  }
}

customElements.define("product-recommendations", ProductRecommendations);
